import CheckboxSwitch from "./CheckboxSwitch.js";

export default class CheckboxDarkModeSwitch extends CheckboxSwitch {
    sendData() {
        const currentTheme = this.element.checked ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', currentTheme);
        super.sendData();
    }
}